function getUrlVars() {
  var vars = [],
    hash;
  var hashes = window.location.href
    .slice(window.location.href.indexOf("?") + 1)
    .split("&");

  for (var i = 0; i < hashes.length; i++) {
    hash = hashes[i].split("=");
    vars.push(hash[0]);
    vars[hash[0]] = hash[1];
  }

  return vars;
}

function getOriginWithExplicitPort() {
  const protocol = window.location.protocol;
  const port = window.location.port;

  // [2026-04-17 修改] 去掉默认端口拼接，避免 test.linkstone.chat:443 导致企业微信回调不匹配
  // 旧逻辑: 空端口时强制加 :80 或 :443
  if (port) {
    return `${protocol}//${window.location.hostname}:${port}`;
  }
  return `${protocol}//${window.location.hostname}`;
}

function isDevelopment() {
  // [2026-05-07] 两个域名统一使用正式企业微信应用
  // test.linkstone.chat 和 linkstone.chat 都用 agent_id=1000040
  return false;
}

function detectDevice() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  let result = "";

  if (/wxwork/i.test(userAgent)) {
    if (/Mobile/i.test(userAgent)) {
      // 手机企业微信端
      result = "mobile_enterprise_wechat";
    } else {
      // 电脑企业微信端
      result = "computer_enterprise_wechat";
    }
  } else if (/Mobile/i.test(userAgent)) {
    // 手机浏览器端
    result = "mobile_browser";
  } else if (/Windows NT|Macintosh|X11/i.test(userAgent)) {
    // 电脑浏览器端
    result = "computer_browser";
  } else {
    // 位置环境，默认返回电脑浏览器端
    result = "computer_browser";
  }

  return result;
}

function isPhoneType() {
  const is_ios =
    /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  if (is_ios) {
    return "is_ios";
  }
}

export {
  getUrlVars,
  getOriginWithExplicitPort,
  isDevelopment,
  detectDevice,
  isPhoneType,
};
